import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '/imports/ui/Button';
import { css } from '/imports/ui/css';
import { defer } from '/imports/utils';

const ButtonDropdownStyled = styled.span`
  position: relative;
  .button-dropdown-items {
    position: absolute;
    display: none;
    right: 0;
    z-index: 3;
    &.show {
      display: block;
    }
    .item {
      border-radius: ${css.inputBorderRadius};
      color: ${css.white};
      background-color: ${css.primaryColor};
      width: 100%;
      min-width: 10rem;
      min-height: 3rem;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-top: 1px solid ${css.white};
      cursor: pointer;
      &:hover {
        background: ${css.primaryColor2};
      }
    }
  }
`;

interface ButtonDropdownProps {
  id?: string;
  label: string | React.ReactNode;
  items: { key: string, onClick?: () => void, label: string | React.ReactNode }[];
}

/** Button that toggles a dropdown menu, closing on outside click. */
export const ButtonDropdown = (props: ButtonDropdownProps) => {
  const { label, items } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    if (!showDropdown) return;
    defer(() => {
      document.body.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (target.closest('.button-dropdown')) { e.preventDefault(); return; }
        setShowDropdown(false);
      }, { once: true });
    });
  }, [showDropdown]);
  return (
    <ButtonDropdownStyled id={props.id} className="button-dropdown">
      <Button onClick={() => setShowDropdown(!showDropdown)}>{label}</Button>
      <div className={`button-dropdown-items${showDropdown ? ' show' : ''}`}>
        {
          items.map((item) => (
            <div key={item.key} className="item" onClick={() => item.onClick?.()}>
              {item.label}
            </div>
          ))
        }
      </div>
    </ButtonDropdownStyled>
  );
};